import { type JSX } from "react";
import { cn } from "./lib/utils";
import { NavIcon } from "./NavIcon";

export interface AppIconProps {
  /** Image URL or data URL from the app's registry entry. */
  icon: string | null | undefined;
  className?: string;
}

/**
 * An app's icon on a fixed-colour tile. The tile colour and the glyph colour are
 * the shell's own (Figma "Icon/Light" and "Icon/Dark"), never the app's, so every
 * app reads the same; the registry SVG is simply laid on top. A monochrome
 * currentColor glyph takes the tile's glyph colour, and artwork keeps its own.
 */
export function AppIcon({ icon, className }: AppIconProps): JSX.Element {
  return (
    <span
      aria-hidden="true"
      data-platform-app-icon=""
      className={cn(
        "flex size-5 shrink-0 items-center justify-center rounded-app-icon bg-shell-app-icon text-shell-app-icon-glyph",
        className
      )}
    >
      <NavIcon icon={icon} className="size-3.5 object-contain" />
    </span>
  );
}
